module.exports = __webpack_public_path__ + "img/exclamation_mark_ic.00ae469.svg";